import React from 'react';
import { IconProps } from '../Icon.types';

const ServiceIcon: React.FunctionComponent<IconProps> = ({ colourFill }) => {
  return (
    <svg width="76" height="76" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76 76">
      <g>
        <path
          fill={colourFill}
          d="M33.51 18.6c-.58 0-.92.12-1.47 1.24a1.18 1.18 0 0 1-2.12 0c-.56-1.12-.9-1.24-1.48-1.24a1.34 1.34 0 0 0-1.35 1.4c0 1.8 1.86 3.88 3.89 5.93 2-2.05 3.88-4.13 3.88-5.93a1.36 1.36 0 0 0-1.35-1.4Z"
        />
        <path
          fill={colourFill}
          d="M39.93 22.48a9 9 0 1 0-8.95 9 9 9 0 0 0 8.95-9ZM24.72 20a3.73 3.73 0 0 1 3.72-3.72 3.41 3.41 0 0 1 2.53 1 3.43 3.43 0 0 1 2.54-1A3.73 3.73 0 0 1 37.23 20c0 3-2.75 5.78-5.42 8.45a1.17 1.17 0 0 1-1.67 0C27.47 25.73 24.72 23 24.72 20Z"
        />
        <path
          fill={colourFill}
          d="M61.46 59.57H31.55s1.79-2.34 2.76-3.77C41 46 50.08 32.66 50.08 24.17c0-11.56-8.57-21-19.1-21s-19.11 9.41-19.11 21c0 8.5 9.12 21.88 15.78 31.65C28.61 57.24 30 60 30 60H4s-1.08.42-1.08 1.07 1.18 1.1 1.18 1.1h57.36a1.3 1.3 0 0 0 0-2.6ZM19.65 22.32A11.33 11.33 0 1 1 31 33.65a11.34 11.34 0 0 1-11.35-11.33ZM51.23 70H10.65a1.31 1.31 0 0 0 0 2.6h40.57a1.31 1.31 0 0 0 0-2.6Z"
        />
      </g>
    </svg>
  );
};

export default ServiceIcon;
